/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_TitleInputs */

const en_hood_title = /** @type {(inputs: Hood_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under the hood`)
};

/**
* | output |
* | --- |
* | "Under the hood" |
*
* @param {Hood_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_title = /** @type {((inputs?: Hood_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_title(inputs)
});